import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { salesTertiaryBlockDefaultStyles } from "../constants";

export interface SalesBlock8Props extends ComponentPropsWithRef<"div"> {
  buttons?: ReactNode;
  header?: ReactNode;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const SalesBlock8 = forwardRef<HTMLDivElement, SalesBlock8Props>(
  (
    { header, leftContent, rightContent, buttons, className, styles, ...rest },
    ref,
  ) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: salesTertiaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          className="wb-bg-button-primary-hover"
          style={backgroundStyles}
        >
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                {header}
              </BlockSection.NestedBlock>
              <div className="wb-bg-primary wb-mx-auto wb-flex wb-max-w-[60.625rem] wb-flex-col wb-gap-10 wb-rounded-2xl wb-p-[1.88rem] md:wb-grid md:wb-grid-cols-2 md:wb-gap-16">
                <BlockSection.NestedBlock className="wb-mx-auto">
                  {leftContent}
                </BlockSection.NestedBlock>
                <div className="wb-flex wb-flex-col wb-gap-4">
                  {rightContent}
                  <BlockSection.NestedBlock className="wb-flex wb-justify-center md:wb-block">
                    {buttons}
                  </BlockSection.NestedBlock>
                </div>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

SalesBlock8.displayName = "SalesBlock8";
